export default "__VITE_ASSET__7ae30a6d__"